import React, {
  useEffect,
  useState,
} from "react";

import axios from "axios";

import RouterPage from "./home/Routerpage";
import CookieConsent from "./home/CookieConsent";

import "./App.css";


const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || ""
).replace(/\/+$/, "");


/*
|--------------------------------------------------------------------------
| META GÜNCELLE
|--------------------------------------------------------------------------
*/
const updateMeta = (name, content = "") => {
  let element = document.querySelector(
    `meta[name="${name}"]`
  );

  /*
   * Değer boşsa mevcut etiketi kaldır.
   */
  if (!content) {
    if (element) {
      element.remove();
    }

    return;
  }

  /*
   * Yoksa oluştur.
   */
  if (!element) {
    element =
      document.createElement("meta");

    element.setAttribute(
      "name",
      name
    );

    document.head.appendChild(
      element
    );
  }

  element.setAttribute(
    "content",
    content
  );
};


/*
|--------------------------------------------------------------------------
| URL OLUŞTUR
|--------------------------------------------------------------------------
*/
const getPublicUrl = (value) => {
  if (!value) {
    return "";
  }

  const url = String(value);

  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("data:")
  ) {
    return url;
  }

  const path = url.startsWith("/")
    ? url
    : `/${url}`;

  return `${API_BASE_URL}${path}`;
};


function App() {
  const [settings, setSettings] =
    useState({
      title_suffix: "",
      favicon: "",
      title: "",
      author: "",
      description: "",
      keywords: "",
    });

  /*
   * null:
   * backend cevabı gelmeden robots
   * etiketiyle oynama.
   */
  const [googleIndex, setGoogleIndex] =
    useState(null);


  /*
  |--------------------------------------------------------------------------
  | 1. HEADER / SEO AYARLARI
  |--------------------------------------------------------------------------
  */
  useEffect(() => {
    const fetchHeaderSettings =
      async () => {
        try {
          const { data } =
            await axios.get(
              `${API_BASE_URL}/api/header`
            );

          const newSettings = {
            title_suffix:
              data?.title_suffix || "",

            favicon:
              data?.favicon || "",

            title:
              data?.title || "",

            author:
              data?.author || "",

            description:
              data?.description || "",

            keywords:
              data?.keywords || "",
          };


          setSettings(
            newSettings
          );


          /*
           * META
           */
          updateMeta(
            "author",
            newSettings.author
          );

          updateMeta(
            "description",
            newSettings.description
          );

          updateMeta(
            "keywords",
            newSettings.keywords
          );


          /*
           * FAVICON
           */
          const favicon =
            document.getElementById(
              "favicon"
            );

          if (
            favicon &&
            newSettings.favicon
          ) {
            favicon.href =
              getPublicUrl(
                newSettings.favicon
              );
          }
        } catch (error) {
          console.error(
            "HEADER_SETTINGS_ERROR:",
            error
          );
        }
      };


    fetchHeaderSettings();
  }, []);


  /*
  |--------------------------------------------------------------------------
  | 2. GOOGLE INDEX
  |--------------------------------------------------------------------------
  */
  useEffect(() => {
    const fetchGoogleIndex =
      async () => {
        try {
          const { data } =
            await axios.get(
              `${API_BASE_URL}/api/header/google-index`
            );

          setGoogleIndex(
            Number(
              data?.google_index
            )
          );
        } catch (error) {
          console.error(
            "GOOGLE_INDEX_ERROR:",
            error
          );
        }
      };


    fetchGoogleIndex();
  }, []);


  /*
  |--------------------------------------------------------------------------
  | 3. ROBOTS META
  |--------------------------------------------------------------------------
  */
  useEffect(() => {
    if (
      googleIndex === null
    ) {
      return;
    }


    let robots =
      document.querySelector(
        'meta[name="robots"]'
      );


    /*
     * Google index kapalı
     */
    if (googleIndex === 0) {
      if (!robots) {
        robots =
          document.createElement(
            "meta"
          );

        robots.setAttribute(
          "name",
          "robots"
        );

        document.head.appendChild(
          robots
        );
      }

      robots.setAttribute(
        "content",
        "noindex, nofollow"
      );

      return;
    }


    /*
     * Google index açık
     */
    if (robots) {
      robots.remove();
    }
  }, [googleIndex]);


  /*
  |--------------------------------------------------------------------------
  | 4. TITLE
  |--------------------------------------------------------------------------
  */
  useEffect(() => {
    const title =
      String(
        settings.title || ""
      ).trim();

    const suffix =
      String(
        settings.title_suffix || ""
      ).trim();


    if (
      title &&
      suffix
    ) {
      document.title =
        `${title} - ${suffix}`;

      return;
    }


    if (title) {
      document.title = title;

      return;
    }


    if (suffix) {
      document.title = suffix;

      return;
    }


    document.title = "";
  }, [
    settings.title,
    settings.title_suffix,
  ]);


  /*
  |--------------------------------------------------------------------------
  | 5. GOOGLE ANALYTICS
  |--------------------------------------------------------------------------
  */
  useEffect(() => {
    const loadAnalytics =
      async () => {
        try {
          const { data } =
            await axios.get(
              `${API_BASE_URL}/api/settings`
            );


          if (
            !data?.google_analytics_api
          ) {
            return;
          }


          const parser =
            new DOMParser();

          const documentData =
            parser.parseFromString(
              data.google_analytics_api,
              "text/html"
            );


          documentData
            .querySelectorAll(
              "script"
            )
            .forEach(
              (script) => {
                const newScript =
                  document.createElement(
                    "script"
                  );


                if (script.src) {
                  newScript.src =
                    script.src;

                  newScript.async =
                    true;
                } else {
                  newScript.text =
                    script.textContent;
                }


                document.head.appendChild(
                  newScript
                );
              }
            );
        } catch (error) {
          console.error(
            "GOOGLE_ANALYTICS_ERROR:",
            error
          );
        }
      };


    loadAnalytics();
  }, []);


  return (
    <div className="App">
      <RouterPage />
      <CookieConsent />
    </div>
  );
}


export default App;